import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Pause = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Pause' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M3,21 L9,21 L9,3 L3,3 L3,21 Z M15,21 L21,21 L21,3 L15,3 L15,21 Z' />
  </StyledIcon>
);
